import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/LoginPage";
import AgentDashboard from "@/pages/AgentDashboard";
import DirectorDashboard from "@/pages/DirectorDashboard";

function Shell() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading-full">Chargement…</div>;
  }

  if (!user) return <LoginPage />;
  if (user.role === "director") return <DirectorDashboard />;
  return <AgentDashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
